<span [appTranslate]="control.name"></span><br>
<label class="radio-bulma" *ngFor="let option of getOptions()">
  <span>
    <input type="radio"
           [(ngModel)]="control.value"
           #name="ngModel"
           [name]="control.name"
           [value]="option.value"
           [required]="control.required"
    >
    <span [appTranslate]="option.value"></span>
  </span>
  <app-field-error [field]="name" [control]="control"></app-field-error>
</label>
